<div class="card">
    <div class="card-body">
        <h4 class="card-title">Editar preguntas Barsit</h4>

        <table id="demo-foo-addrow2" class="table table-bordered table-hover toggle-circle " >
            <thead>
                <tr>
                    <th>#</th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Titulo<span class="footable-sort-indicator"></span></th>
                    <th class="min-width footable-visible footable-last-column">Editar/Eliminar</th>
                </tr>
            </thead>
            
            <tbody>
                <tr *ngFor="let question of questions">
                    <td>{{question.index}}</td>
                    <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.title}}</td>
                    <td class="footable-visible footable-last-column text-center">
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " data-toggle="modal" data-target="#myModal" (click)="handleEdit(question._id)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(question._id)" ><i class="fa fa-eraser" ></i></button>
                    
                    </td>
                </tr>
            </tbody>
     
        </table>
    </div>
</div>

<div id="myModal" data-backdrop="static" data-keyboard="false" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-lg p-20">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">Barsit</h4>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="card-body">
                <form [formGroup]="barsicForm" (ngSubmit)="update()">
                    <div class="row">
                        <div class="col-md-6">
                            <div  >
                                <label class="control-label">Tipo de pregunta</label>
                                <select formControlName="type" (change)="setSelectedPart($event)" class="form-control custom-select">
                                    <option selected value="text">Texto</option>
                                    <option value="number">Numérica</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-body">
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Título</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                </div>
                            </div>
                            <div class="col-md-6 ">    
                                <div  >
                                    <label class="control-label">Factor</label>
                                    <select formControlName="factor" class="form-control custom-select">
                                        <option selected value="informacion">Información</option>
                                        <option value="razonamientoVerbal">Razonamiento verbal</option>
                                        <option value="comprensionDeVocabulario">Comprensión de vocabulario</option>
                                        <option value="razonamientoLogico">Razonamiento lógico</option>
                                        <option value="razonamientoNumerico">Razonamiento Numerico</option>
                                    </select>
                                </div>
                            </div>
                            <!--/span-->
                            <div *ngIf="type=='text'" class="m-t-20">

                                <div class="row col-md-12" formGroupName="opcA">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción A</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción A">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción A</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción A">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row col-md-12" formGroupName="opcB">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción B</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción B">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción B</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción B">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row col-md-12" formGroupName="opcC">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción C</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción C">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción C</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción C">
                                        </div>
                                    </div>
                                </div>
                                <div class="row col-md-12" formGroupName="opcD">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción D</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción D">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción D</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción D">
                                        </div>
                                    </div>
                                    
                                </div>
                                <div class="row col-md-12" formGroupName="opcE">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción E</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción E">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción E</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción E">
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            <div *ngIf="type=='number'" class="col-12 m-t-20">
 
                                <div class="col-md-12">    
                                    <div class="form-group">
                                        <label class="control-label">Agregue los números. El valor 0 será tomado como variable</label>
                                        <div class="row">
                                            <div class="col-sm-8">
                                                <input [(ngModel)]="number" [ngModelOptions]="{standalone: true}" type="number"  class="form-control"  >
                                            </div>
                                            <div class="col-sm-4">
                                                <button type="button" class="btn btn-info btn-circle" (click)="addNumber()"><i class="fa fa-plus"></i> </button>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div *ngFor="let n of numbers" class="col-sm-1">
                                                <p>
                                                    {{n}}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-12">    
                                    <div class="form-group">
                                        <label class="control-label">Agregue los números correctos</label>
                                        <div class="row">
                                            <div class="col-sm-8">
                                                <input [(ngModel)]="correctNumber" [ngModelOptions]="{standalone: true}" type="number"  class="form-control" >
                                            </div>
                                            <div class="col-sm-4">
                                                <button type="button" class="btn btn-info btn-circle" (click)="addCorrectNumber()"><i class="fa fa-plus"></i> </button>
                                            </div>
                                            
                                        </div>
                                        <div class="row">
                                            <div *ngFor="let n of correctNumbers" class="col-sm-1">
                                                <p>
                                                    {{n}}
                                                </p>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="col-md-6">    
                                    <div class="form-group">
                                        <label class="control-label">Puntaje</label>
                                        <input [formControl]="barsicForm.controls.correctNumberValue"  type="number"  class="form-control" placeholder="Puntaje">
                                    </div>
                                </div>

                            </div>


                        </div>
                        
                        
                    </div>
                    <div class="col-md-6">    
                        <div class="form-group">
                            <label class="control-label">Ìndice</label>
                            <input formControlName="index" type="number" class="form-control" placeholder="Índice">
                        </div>
                    </div>
                    <div class="form-actions m-t-20">
                        <button type="submit" class="btn btn-success m-r-20"> <i class="fa fa-check"></i> Actualizar</button>
                    </div>
                    <div class="form-actions m-t-20">
                        <button *ngIf="type=='number'" class="btn btn-warning m-r-20" type="button" (click)="resetNumbers()"> <i class="fa fa-minus"></i> Borrar números</button>
                    </div>
                </form>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

